var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoryBulkPurchaseTransaction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5417 4.79167H15.2083C16.1288 4.79167 16.875 5.53786 16.875 6.45833V8.95833M13.5417 4.79167V8.95833M13.5417 4.79167C13.5417 3.87119 12.7955 3.125 11.875 3.125H4.79166C3.87118 3.125 3.12499 3.87119 3.12499 4.79167V6.45833M16.875 8.95833C17.3352 8.95833 17.7083 9.33142 17.7083 9.79167V14.375C17.7083 15.7557 16.5891 16.875 15.2083 16.875H4.79166C3.41095 16.875 2.29166 15.7557 2.29166 14.375V7.29167C2.29166 6.83143 2.66476 6.45833 3.12499 6.45833M16.875 8.95833H13.5417M13.5417 8.95833H10.8272C10.1642 8.95833 9.52824 8.69492 9.05941 8.2261L8.02389 7.19057C7.55505 6.72173 6.91917 6.45833 6.25612 6.45833H3.12499",
    stroke: "currentColor",
    strokeOpacity: 0.8,
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryBulkPurchaseTransaction);
export default __webpack_public_path__ + "static/media/history_bulk_purchase_transaction.a4c9943a5fa69eaef1e36fbfc6c2a294.svg";
export { ForwardRef as ReactComponent };